let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lKmFv")).then(() => parcelRequire('719qB'));